import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiTrendingUp, FiTrendingDown } = FiIcons;

const SalesPerformanceTable = ({ timeline, onProductClick }) => {
  const salesData = [
    {
      id: 1,
      productName: 'Abiraterone Acetate Tablets',
      ndc: '72578-001-30',
      totalSales: 45200000,
      volumeEaches: 2850000,
      volumeNSP: 1425000,
      growth: 12.5,
      trend: 'up'
    },
    {
      id: 2,
      productName: 'Atorvastatin Tablets',
      ndc: '72578-002-90',
      totalSales: 38750000,
      volumeEaches: 4200000,
      volumeNSP: 2100000,
      growth: 8.3,
      trend: 'up'
    },
    {
      id: 3,
      productName: 'Rosuvastatin Tablets',
      ndc: '72578-003-30',
      totalSales: 32100000,
      volumeEaches: 1850000,
      volumeNSP: 925000,
      growth: -2.1,
      trend: 'down'
    },
    {
      id: 4,
      productName: 'Losartan Tablets',
      ndc: '72578-004-100',
      totalSales: 28900000,
      volumeEaches: 3100000,
      volumeNSP: 1550000,
      growth: 15.7,
      trend: 'up'
    },
    {
      id: 5,
      productName: 'Capecitabine Tablets',
      ndc: '72578-005-60',
      totalSales: 24600000,
      volumeEaches: 450000,
      volumeNSP: 225000,
      growth: 22.4,
      trend: 'up'
    },
    {
      id: 6,
      productName: 'Levetiracetam Tablets',
      ndc: '72578-006-100',
      totalSales: 19800000,
      volumeEaches: 1200000,
      volumeNSP: 600000,
      growth: 5.9,
      trend: 'up'
    },
    {
      id: 7,
      productName: 'Sacubitril/Valsartan Tablets',
      ndc: '72578-007-28',
      totalSales: 16500000,
      volumeEaches: 280000,
      volumeNSP: 140000,
      growth: 31.2,
      trend: 'up'
    }
  ];

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat('en-US').format(num);
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="bg-gray-50 border-b border-gray-200">
            <th className="text-left py-4 px-6 font-semibold text-gray-900">Product Name</th>
            <th className="text-left py-4 px-6 font-semibold text-gray-900">NDC No.</th>
            <th className="text-right py-4 px-6 font-semibold text-gray-900">Total Sales (USD)</th>
            <th className="text-right py-4 px-6 font-semibold text-gray-900">Volume (Eaches)</th>
            <th className="text-right py-4 px-6 font-semibold text-gray-900">Volume (NSP Ext Units)</th>
            <th className="text-right py-4 px-6 font-semibold text-gray-900">Growth</th>
          </tr>
        </thead>
        <tbody>
          {salesData.map((product, index) => (
            <motion.tr
              key={product.id}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.05 }}
              className="border-b border-gray-100 hover:bg-gray-50 cursor-pointer transition-colors"
              onClick={() => onProductClick(product.productName)}
            >
              <td className="py-4 px-6">
                <div>
                  <p className="font-medium text-gray-900 hover:text-blue-600 transition-colors">
                    {product.productName}
                  </p>
                  <p className="text-sm text-gray-500">Click to view details</p>
                </div>
              </td>
              <td className="py-4 px-6">
                <span className="font-mono text-sm bg-gray-100 px-2 py-1 rounded">
                  {product.ndc}
                </span>
              </td>
              <td className="py-4 px-6 text-right">
                <span className="font-semibold text-gray-900">
                  {formatCurrency(product.totalSales)}
                </span>
              </td>
              <td className="py-4 px-6 text-right">
                <span className="text-gray-700">
                  {formatNumber(product.volumeEaches)}
                </span>
              </td>
              <td className="py-4 px-6 text-right">
                <span className="text-gray-700">
                  {formatNumber(product.volumeNSP)}
                </span>
              </td>
              <td className="py-4 px-6 text-right">
                <div className="flex items-center justify-end gap-1">
                  <SafeIcon 
                    icon={product.trend === 'up' ? FiTrendingUp : FiTrendingDown}
                    className={`text-sm ${product.growth >= 0 ? 'text-green-600' : 'text-red-600'}`}
                  />
                  <span className={`font-medium ${product.growth >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                    {product.growth >= 0 ? '+' : ''}{product.growth}%
                  </span>
                </div>
              </td>
            </motion.tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SalesPerformanceTable;